import { useQueryClient } from '@tanstack/react-query';
import { Editor } from '@tiptap/core';
import { ConditionalTextForm } from 'components/resources/conditional-texts/form/ConditionalTextForm';
import InfoBoxForm from 'components/resources/infobox/InfoBoxForm';
import RefManagerForm from 'components/resources/reference-manager/refManagerForm';
import { ModuleContext } from 'components/utils/module/ModuleContext';
import { SlidePanel } from 'components/utils/panels/AvoSlidePanel';
import { useContext } from 'react';

interface TiptapAddNewItemProps {
  id?: string;
  editor: Editor;
  open: boolean;
  itemType: string;
  toggleModal: () => void;
}

export const AddNewItem = ({ id, editor, open, itemType, toggleModal }: TiptapAddNewItemProps) => {
  const queryClient = useQueryClient();
  const { module: selectedModule } = useContext(ModuleContext);
  const addItem = (item) => {
    queryClient.invalidateQueries({
      queryKey: ['module', selectedModule?.type, selectedModule?.id, 'resources'],
    });
    if (id) {
      editor
        .chain()
        .focus()
        .updateAttributes('mention', { name: item?.title || item?.name || item?.source })
        .run();
    } else {
      editor.commands.insertContent({
        type: 'mention',
        attrs: {
          id: item?.id,
          type: item.type,
          code: item?.unique_code,
          name: item?.name || item?.title || item?.source,
        },
      });
    }
  };

  return (
    <SlidePanel open={open} onClose={toggleModal} supportLegacyFormWidth={itemType === 'infobox'}>
      {itemType === 'infobox' && (
        <InfoBoxForm
          infoBoxId={id}
          type={selectedModule?.type}
          toggleModal={toggleModal}
          savePosition={() => []}
          selectValue={addItem}
        />
      )}
      {itemType === 'conditional_text' && (
        <>
          <ConditionalTextForm
            conditionalTextId={Number(id) || undefined}
            onCancel={toggleModal}
            onSave={(item) => {
              addItem(item);
              toggleModal();
            }}
          />
        </>
      )}
      {itemType === 'reference' && (
        <div className='p-4 pt-[20px]'>
          <RefManagerForm
            addItem={addItem}
            refManagerId={id}
            type={selectedModule?.type}
            toggleModal={toggleModal}
            savePosition={() => []}
          />
        </div>
      )}
    </SlidePanel>
  );
};
